module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/wasm-module.e77e7814c2ffe2791bc5.js");
};